/* eslint-disable camelcase */
import { StyleSheet, View } from '@react-pdf/renderer';
import React from 'react';
import dayjs from 'libs/dayjs';import P from 'PDF/Elements/Text/P';

dayjs.locale('es');

const styles = StyleSheet.create({
  voucherData: {
    flexDirection: 'column',
    gap: '0.8cm',
  },
  dataSection: {
    backgroundColor: '#f8f9fa',
    borderRadius: '0.2cm',
    padding: '0.6cm',
    border: '1px solid #e8e8e8',
  },
  row: {
    flexDirection: 'row',
    width: '100%',
    marginBottom: '0.4cm',
    alignItems: 'center',
  },
  label: {
    flex: 1,
    fontSize: '10px',
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  value: {
    flex: 2,
    fontSize: '11px',
    fontFamily: 'Helvetica',
    color: '#34495e',
    paddingLeft: '0.5cm',
    borderLeft: '2px solid #548235',
    textTransform: 'capitalize',
  },
  gridRow: {
    flexDirection: 'row',
    gap: '0.5cm',
  },
  gridItem: {
    flex: 1,
    backgroundColor: '#ffffff',
    borderRadius: '0.2cm',
    padding: '0.4cm',
    border: '1px solid #e8e8e8',
    textAlign: 'center',
  },
  gridLabel: {
    fontSize: '9px',
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    marginBottom: '0.2cm',
  },
  gridValue: {
    fontSize: '11px',
    fontFamily: 'Helvetica',
    color: '#34495e',
    textTransform: 'capitalize',
  },
});

function OrderData(props) {
  const { data } = props;
  const {
    specialist_name,
    recepcionist_name,
    client_name,
    order_init,
    client_rut,
  } = data;

  return (
    <View style={styles.voucherData}>
      {/* Información de Personas */}
      <View style={styles.dataSection}>
        <View style={styles.gridRow}>
          <View style={styles.gridItem}>
            <P style={styles.gridLabel}>Especialista</P>
            <P style={styles.gridValue}>{specialist_name}</P>
          </View>
          <View style={styles.gridItem}>
            <P style={styles.gridLabel}>Recibe</P>
            <P style={styles.gridValue}>{recepcionist_name}</P>
          </View>
          <View style={styles.gridItem}>
            <P style={styles.gridLabel}>Cliente</P>
            <P style={styles.gridValue}>{client_name}</P>
          </View>
        </View>
      </View>

      {/* Información de Fechas y Datos */}
      <View style={styles.dataSection}>
        <View style={styles.row}>
          <P style={styles.label}>Tipo:</P>
          <P style={styles.value}>ODT</P>
        </View>
        <View style={styles.row}>
          <P style={styles.label}>Fecha de Emisión:</P>
          <P style={styles.value}>
            {dayjs().format('DD [de] MMMM [del] YYYY')}
          </P>
        </View>
        <View style={styles.row}>
          <P style={styles.label}>Inicio de Orden:</P>
          <P style={styles.value}>
            {dayjs(order_init).format('DD [de] MMMM [del] YYYY')}
          </P>
        </View>
        <View style={styles.row}>
          <P style={styles.label}>RUT Cliente:</P>
          {/* No eliminar el {} porque si se elimina no aparece el digito verificador */}
          <P style={styles.value}>
            {client_rut} {}
          </P>
        </View>
      </View>
    </View>
  );
}


export default OrderData;
